import ProductSelect from './CustomSelect';

export default ProductSelect;
